export default "__VITE_ASSET__CVXeBmlv__"